import { Modal } from 'flowbite-react';
import { IMaintenance } from '../../../../types/maintenance.type';
import { GeneratePdfBudgetMaintenance } from '../forms/generate-pdfs/GeneratePdfBudgetMaintenance';

type CreatePDFPropsBudgetMaintenance = {
  data: IMaintenance,
  onClose: () => void
};

export default function ModalGeneratePDFMaintenance(props: CreatePDFPropsBudgetMaintenance) {
  return (
    <Modal
      className='relative dark:text-black '
      show={true}
      onClose={() => props.onClose()}
    >
      <Modal.Header className='dark:text-black'>
        <h2 className='dark:text-black'>Gerar PDF</h2>
      </Modal.Header>

      <Modal.Body className='w-full relative items-center justify-center border-gray flex flex-col' style={{ minHeight: 'calc(80vh - 200px)', height: 'calc(50vh - 100px)' }}>
        <div className='pb-[24px]'>
          <h2 className="font-semibold">Clique aqui para gerar PDF:</h2>
        </div>
        <div>
          <GeneratePdfBudgetMaintenance data={props.data} />
        </div>
      </Modal.Body>

      <Modal.Footer>
      </Modal.Footer>

    </Modal >
  );
}
